import React from 'react';
import { Link } from 'react-router-dom';

/**
 * LogoMark — uses the custom Lockene mosaic mark next to a Cormorant wordmark.
 * Variant switches the wordmark colour (light footer uses "alabaster").
 */
const LogoMark = ({ variant = 'oxford', to = '/' }) => {
  const wordColor = variant === 'alabaster' ? '#F8F7F4' : '#0A1128';

  return (
    <Link
      to={to}
      className="inline-flex items-center gap-3 focus-ring rounded-sm"
      aria-label="Lockene — home"
      data-testid="brand-logo"
    >
      <img
        src="/images/logo/lockene-mosaic.png"
        alt=""
        aria-hidden="true"
        className="h-9 w-9 md:h-10 md:w-10 object-contain select-none"
        draggable="false"
      />
      <span
        className="font-display text-2xl md:text-[26px] tracking-tight leading-none"
        style={{ color: wordColor }}
      >
        Lockene
      </span>
    </Link>
  );
};

export default LogoMark;
